import React, { useRef, ChangeEvent } from 'react';

import Checkbox from '1-core/FormElements/Checkbox';

interface CustomToggleSoldRefinementListProps {
    label: string;
    defaultValue?: boolean;
    onChange?: (event: ChangeEvent) => void // eslint-disable-line no-unused-vars
}

const CustomToggleSoldRefinementList = ({ label, defaultValue, onChange }: CustomToggleSoldRefinementListProps) => {
    const wrapperRef = useRef<HTMLDivElement>(null);

    return (
        <div ref={wrapperRef} className="custom-refinement-list tablet-version">
            <Checkbox
                checkboxId="custom-refinement-checkbox"
                checkboxLabel={label}
                notRequired={true}
                elementCustomClass="filter-checkbox"
                checkboxOnChange={onChange}
                checkboxDefaultValue={defaultValue}
            />
        </div>
    );
};

export default CustomToggleSoldRefinementList;
